import React, { useState } from 'react'
import {
  Signature as KSignature,
  SignatureChangeEvent,
} from "@progress/kendo-react-inputs";
import CustomButton from '../../stateless/customButton/CustomButton';

const Signature = () => {
  const [value, setValue] = useState<string>('test signature');
  const [showUpload, setShowUpload] = useState<boolean>(true);
  const [imageURL, setImageURL] = useState<boolean>(true);

  const onChange = (e: SignatureChangeEvent) => {
    setValue(e.value);
  };

  const submitSignature = (e: any) => {
    e.preventDefault();
  }

  const uploadSignature = (e: any) => {
    e.preventDefault();
  }

  return (
    <div style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
      <p>Signature</p>
      <KSignature
        value={value}
        onChange={onChange}
        color="black"
        smooth={true}
        maximizable={false}
        style={{ width: '50%', height: '100%' }}
      />
      <div>
        <CustomButton onClick={submitSignature} size="small">Submit Signature</CustomButton>
        <CustomButton onClick={uploadSignature} size="small">Upload Signature</CustomButton>
      </div>
    </div>
  )
}

export default Signature